import { GokuDataGridProps } from 'vnetwork-ui/dist/components/GokuDataGrid'
import { useQuery } from '@tanstack/react-query'
import { GokuDataGrid as GokuDataGridVNW } from 'vnetwork-ui'
import { useMemo } from 'react'

const GokuDataGrid = <T extends object, R extends object, S extends string>(
    props: Omit<GokuDataGridProps<T, R, S>, 'useQuery'>
) => {
    // Clone columns to prevent mutation by vnetwork-ui GokuDataGrid
    // The library mutates columns directly which causes re-render issues
    const clonedColumns = useMemo(
        () => props.columns?.map((col) => ({ ...col })) || [],
        [props.columns]
    )

    // Clone dataGridProps to prevent mutation
    const clonedDataGridProps = useMemo(
        () => ({ ...props.dataGridProps }),
        [props.dataGridProps]
    )

    // @ts-ignore
    return (
        <GokuDataGridVNW
            {...props}
            columns={clonedColumns}
            dataGridProps={clonedDataGridProps}
            useQuery={useQuery}
        />
    )
}

export default GokuDataGrid
